import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UseOfProceedsCreateModalUI from './UseOfProceedsCreateModalUI'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'

class UseOfProceedsCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      billName: '',
      billNameError: null,
      vendorId: '',
      vendorIdError: null,
      billAmount: '',
      billAmountError: null,
      chartOfAccountCode: '',
      chartOfAccountCodeError: null,
      chartOfAccountList: null,
      taxSlabCode: '',
      taxSlabCodeError: null,
      dueDate: '',
      dueDateError: null,
      notes: '',
      notesError: null,
      UseOfProceedsPageSF: null,
      chartOfAccountList: [],
      vendorList: null,
      vendorList: [],
    }
  }

  render() {
    let taxSlabList = [
      { key: 'gst_0', value: '0' },
      { key: 'gst_5', value: '5' },
      { key: 'gst_12', value: '12' },
      { key: 'gst_18', value: '18' },
      { key: 'gst_28', value: '28' }
    ]
    return (
      <UseOfProceedsCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        vendorId={this.state.vendorId}
        onVendorIdChange={(event) => { this.setState({ vendorId: event.target.value }) }}
        vendorIdError={this.state.vendorIdError}
        setVendorIdError={(error) => { this.setState({ vendorIdError: error }) }}
        vendorList={this.state.vendorList}
        // 
        billName={this.state.billName}
        onBillNameChange={(event) => { this.setState({ billName: event.target.value }) }}
        billNameError={this.state.billNameError}
        setBillNameError={(error) => { this.setState({ billNameError: error }) }}
        //
        billAmount={this.state.billAmount}
        onBillAmountChange={(event) => { this.setState({ billAmount: event.target.value }) }}
        billAmountError={this.state.billAmountError}
        setBillAmountError={(error) => { this.setState({ billAmountError: error }) }}
        //
        chartOfAccountCode={this.state.chartOfAccountCode}
        onChartOfAccountCodeChange={(event) => { this.setState({ chartOfAccountCode: event.target.value }) }}
        chartOfAccountCodeError={this.state.chartOfAccountCodeError}
        setChartOfAccountCodeError={(error) => { this.setState({ chartOfAccountCodeError: error }) }}
        chartOfAccountList={this.state.chartOfAccountList}

        //
        taxSlabCode={this.state.taxSlabCode}
        onTaxSlabCodeChange={(event) => { this.setState({ taxSlabCode: event.target.value }) }}
        taxSlabCodeError={this.state.taxSlabCodeError}
        setTaxSlabCodeError={(error) => { this.setState({ taxSlabCodeError: error }) }}
        taxSlabList={taxSlabList}
        // dueDate
        dueDate={this.state.dueDate}
        onDueDateChange={(selectedDateISO) => {
          this.setState({ dueDate: selectedDateISO })
        }}
        dueDateError={this.state.dueDateError}
        setDueDateError={(error) => { this.setState({ dueDateError: error }) }}
        //
        notes={this.state.notes}
        onNotesChange={(event) => { this.setState({ notes: event.target.value }) }}
        notesError={this.state.notesError}
        setNotesError={(error) => { this.setState({ notesError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    this.getChartOfAccounts(context)
    this.getVendors(context)
  }

  getChartOfAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/chartOfAccounts`,
      cacheKey: CacheKeys.ChartOfAccounts(),
      callback: this.getChartOfAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getChartOfAccountsCallback = (response) => {
    let chartOfAccountList = response.chartOfAccountList.filter(acc => acc.vendorPaymentEnabled === true).map(account => ({
      key: account.chartOfAccountCode,
      value: account.chartOfAccountName
    }))
    this.setState({ errorList: response.errorList, chartOfAccountList: chartOfAccountList })
  }

  getVendors(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.loan.accountId}/vendors`,
      cacheKey: CacheKeys.Vendors(this.props.loan.accountId),
      callback: this.getVendorsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getVendorsCallback = (response) => {
    console.log(response.vendorList)
    let vendorList = response.vendorList.map(vendor => ({
      key: vendor.vendorId,
      value: vendor.vendorName
    }));

    this.setState({
      errorList: response.errorList,
      vendorList: vendorList
    });
  };


  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/vendor/${this.state.vendorId}/vendorBills`,
      this.onSubmitCallback, {
      vendorId: this.state.vendorId,
      billName: this.state.billName,
      billAmount: this.state.billAmount,
      chartOfAccountCode: this.state.chartOfAccountCode,
      taxSlabCode: this.state.taxSlabCode,
      dueDate: this.state.dueDate,
      notes: this.state.notes,
    }
    )
  }



  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(UseOfProceedsCreateModalSF)
